/**
 * Gamification definitions (docs/PRODUCT.md §5).
 *
 * Weekly, not daily: this is a once-a-week product, and a daily streak would
 * punish people for using it as designed. No leaderboards — comparing health
 * numbers between users is pressure we do not want to create.
 */
export const BADGES = [
    { id: 'first-session', name: 'First look', description: 'Completed your first session.' },
    { id: 'full-hour', name: 'Full hour', description: 'Finished a 60-minute session.' },
    { id: 'three-weeks', name: 'Three in a row', description: 'Three consecutive weeks with a session.' },
    {
        id: 'thirty-minute-hold',
        name: 'Half-hour hold',
        description: 'Went 30 minutes before your first slip.',
    },
    { id: 'esa-five-up', name: 'Five degrees', description: 'Neck angle up 5° on your 4-week average.' },
    {
        id: 'feedback-ten',
        name: 'Ten corrections',
        description: 'Sent feedback on ten sessions — detection gets better because of this.',
    },
    { id: 'exercise-week', name: 'Seven days moving', description: 'Logged an exercise seven days running.' },
];
export const STAGE_NAMES = {
    1: 'Knuckle-walker',
    2: 'Half-upright',
    3: 'Walker',
    4: 'Upright',
    5: 'Peak',
};
/**
 * Stage comes from the 4-week moving average, never a single session, so one bad
 * afternoon cannot devolve the character (PRODUCT §5).
 */
export function stageFromAvgScore(avg4wScore) {
    if (avg4wScore >= 88)
        return 5;
    if (avg4wScore >= 76)
        return 4;
    if (avg4wScore >= 62)
        return 3;
    if (avg4wScore >= 45)
        return 2;
    return 1;
}
/** Week key (UTC Monday) used by the weekly stats rollup and streaks. */
export function weekStartMs(timestamp) {
    const date = new Date(timestamp);
    const day = date.getUTCDay();
    const offset = (day + 6) % 7; // Monday = 0
    return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() - offset, 0, 0, 0, 0);
}
//# sourceMappingURL=badges.js.map